import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3bd09a40"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "micro-error-tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["microphone-container", {
      playing: _ctx.ready && !_ctx.microError
    }]),
    ref: "microPhoneRef"
  }, null, 2), _ctx.microErrorText ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.microErrorText), 1)) : _createCommentVNode("", true)]);
}